// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * GLOBAL STYLES
 * 
 * Dark theme with #0f172a background color for all pages
 */

* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

html {
    background-color: #0f172a !important;
    height: 100%;
}

body {
    background-color: #0f172a !important;
    color: #f1f5f9;
    font-family: 'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Oxygen',
        'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
        sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    min-height: 100vh;
    height: 100%;
}

#root {
    background-color: #0f172a !important;
    min-height: 100vh;
    height: 100%;
}

/* Ensure all major containers have the dark background */
.MuiBox-root {
    background-color: transparent;
}

/* Custom scrollbar for dark theme */
::-webkit-scrollbar {
    width: 8px;
}

::-webkit-scrollbar-track {
    background: #1e293b;
}

::-webkit-scrollbar-thumb {
    background: #475569;
    border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
    background: #64748b;
}

/* Loading states */
.loading-container {
    background-color: #0f172a !important;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;;;EAIE;;AAEF;IACI,SAAS;IACT,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI,oCAAoC;IACpC,YAAY;AAChB;;AAEA;IACI,oCAAoC;IACpC,cAAc;IACd;;kBAEc;IACd,mCAAmC;IACnC,kCAAkC;IAClC,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,oCAAoC;IACpC,iBAAiB;IACjB,YAAY;AAChB;;AAEA,yDAAyD;AACzD;IACI,6BAA6B;AACjC;;AAEA,oCAAoC;AACpC;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,mBAAmB;AACnB;IACI,oCAAoC;AACxC","sourcesContent":["/**\n * GLOBAL STYLES\n * \n * Dark theme with #0f172a background color for all pages\n */\n\n* {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n}\n\nhtml {\n    background-color: #0f172a !important;\n    height: 100%;\n}\n\nbody {\n    background-color: #0f172a !important;\n    color: #f1f5f9;\n    font-family: 'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Oxygen',\n        'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n        sans-serif;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    min-height: 100vh;\n    height: 100%;\n}\n\n#root {\n    background-color: #0f172a !important;\n    min-height: 100vh;\n    height: 100%;\n}\n\n/* Ensure all major containers have the dark background */\n.MuiBox-root {\n    background-color: transparent;\n}\n\n/* Custom scrollbar for dark theme */\n::-webkit-scrollbar {\n    width: 8px;\n}\n\n::-webkit-scrollbar-track {\n    background: #1e293b;\n}\n\n::-webkit-scrollbar-thumb {\n    background: #475569;\n    border-radius: 4px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n    background: #64748b;\n}\n\n/* Loading states */\n.loading-container {\n    background-color: #0f172a !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
